import { computed } from "vue";
import { useContractCreateStore } from "../contract-create-store";
import type { ILoaderData } from "nlb-buy-go-library";
import { usePublicStore } from "../../public/store";

export function useLoaderData() {
    const contractCreateStore = useContractCreateStore();
    const publicStore = usePublicStore();

    const PublicLoaderData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: publicStore.flowData.isViewDataLoading
        }),
        set: (newValues: ILoaderData) => {
            publicStore.flowData.isViewDataLoading = newValues.isViewDataLoading;
        }
    });

    const ViewLoaderData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: contractCreateStore.AppState.ProcessData.isViewDataLoading
        }),
        set: (newValues: ILoaderData) => {
            contractCreateStore.AppState.ProcessData.isViewDataLoading = newValues.isDataLoading;
        }
    });

    const AppLoaderData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: contractCreateStore.AppState.ProcessData.isAppDataLoading
        }),
        set: (newValues: ILoaderData) => {
            contractCreateStore.AppState.ProcessData.isAppDataLoading = newValues.isDataLoading;
        }
    });

    return { ViewLoaderData, AppLoaderData, PublicLoaderData };
}
